export default __webpack_public_path__ + "static/media/background-kpmg.7124b223.jpg";